const Nodes = el => Array.from(el);
const Elements = el => document.querySelectorAll(el);
const parseTagMethod = (originalTag, customTag, classNames) => {
    const newTag = document.createElement(customTag);

    newTag.classList.add(...classNames);
    newTag.innerHTML = originalTag.innerHTML;
    originalTag.replaceWith(newTag);
};

const mainMenu = document.querySelector("#globalHeader");
const hamburger = document.querySelector(".gHeader__icon--toggle");
const tierTwoFirstLink = document.querySelector(".gHeader__li--tierTwo");
const tierTwoLastLinks = Array.from(document.querySelectorAll(
    ".gHeader__li--dropdown.gHeader__li--tierTwo"
));
const tierTwoLastLink = tierTwoLastLinks[tierTwoLastLinks.length - 1];
const tierThreeFirstLink = document.querySelector(".gHeader__li--tierThree");
const shopAppFirstLink = document.querySelector(".gHeader__li--isFirstItem");
const specialLinks = Nodes(Elements(".gHeader__a--special"));
const specialBackLinks = Nodes(Elements(".backToSpecialLink"));
const allParentItemLinks = Nodes(Elements(".parentLinkItem"));
const allBackToParentLinks = Nodes(Elements(".backToParentLink"));
const allParentLinks = Nodes(Elements(".parentLink"));
const contentBodies = Nodes(Elements(".gHeader__dContent__body"));
const thirdLevelCategoryList = Nodes(
    Elements(".gHeader__li--tierTwo:first-child .gHeader__ul--l3")
);
const thirdLevelApplicationList = Nodes(
    Elements(".gHeader__li--tierTwo:last-child .gHeader__ul--l3")
);
const fourthLevelList = Nodes(
    Elements(".gHeader__li--tierTwo:first-child .gHeader__dContent--l4")
);
const tierTwoLinks = Nodes(Elements(".gHeader__li--tierTwo"));
const tierThreeLinks = Nodes(Elements(".gHeader__li--tierThree"));
const allSpecialULs = Nodes(Elements(".gHeader__dContent__ul--special"));
const allSpecialHeadings = Nodes(
    Elements(".gHeader__dContent__specialHeading")
);

const paginationLogic = element => {
    const items = element.querySelectorAll(".gHeader__dContent__li");

    const next = element.querySelector(".gHeader__pagination__link--next");

    const prev = element.querySelector(".gHeader__pagination__link--prev");

    const text = element.querySelector(".gHeader__pagination__text");

    Nodes(items).forEach(() => {
        let currentPage = 1;

        let records = 14;

        const prevPage = e => {
            e.preventDefault();
            if (currentPage > 1) {
                currentPage--;
                changePage(currentPage);
            }
        };

        const nextPage = e => {
            e.preventDefault();
            if (currentPage < totalPages()) {
                currentPage++;
                changePage(currentPage);
            }
        };

        const totalPages = () => {
            const rawQuotient = Math.ceil(items.length / records);
            const remainder = rawQuotient % 1;
            const quotient = rawQuotient - remainder;

            return quotient;
        };

        const changePage = page => {
            if (page < 1) page = 1;
            items.forEach(item =>
                item.classList.remove("gHeader__dContent__li--visible")
            );
            for (let i = (page - 1) * records; i < page * records; i++) {
                if (!items[i]) break;
                items[i].classList.add("gHeader__dContent__li--visible");
            }
            text.innerHTML = page + "/" + totalPages();
            if (page === totalPages()) {
                next.style.visibility = "hidden";
                prev.style.visibility = "visible";
            } else if (page === 1) {
                prev.style.visibility = "hidden";
                next.style.visibility = "visible";
            } else {
                prev.style.visibility = "visible";
                next.style.visibility = "visible";
            }
            if (items.length <= records) {
                next.style.display = "none";
                prev.style.display = "none";
                text.style.display = "none";
                text.parentElement.style.display = "none";
            }
        };

        changePage(1);
        prev.addEventListener("click", prevPage);
        next.addEventListener("click", nextPage);
    });
};

const paginationInit = () => {
    const paginationList = Nodes(Elements(".gHeader__dContent__ul"));

    Array.from(paginationList).forEach(paginationLogic);
};

const specialLinksLogic = () => {
    specialLinks.forEach(item => {
        item.addEventListener("click", e => {
            e.preventDefault();
            const href = e.currentTarget.getAttribute("href").replace("#", "");
            const parent =
                e.currentTarget.parentElement.parentElement.parentElement
                    .parentElement;

            const oldUl = parent.querySelector(
                ".gHeader__dContent__ul--special"
            );

            oldUl.classList.replace(
                "gHeader__dContent__ul--special",
                "gHeader__dContent__ul--nonspecial"
            );
            Nodes(
                parent.querySelectorAll(".gHeader__dContent__specialHeading")
            ).forEach(item => {
                item.classList.replace(
                    "gHeader__dContent__specialHeading",
                    "gHeader__dContent__nonspecialHeading"
                );
            });
            Nodes(
                parent.querySelectorAll(".gHeader__dContent__details")
            ).forEach(node => {
                if (
                    node.querySelector(".gHeader__dContent__ul--nonspecial")
                        .id === href
                ) {
                    node.nextSibling.classList.replace(
                        "gHeader__dContent__nonspecialHeading",
                        "gHeader__dContent__specialHeading"
                    );
                }
            });
            Nodes(
                parent.querySelectorAll(".gHeader__dContent__ul--nonspecial")
            ).forEach(node => {
                if (node.id === href) {
                    Nodes(
                        node.parentElement.querySelectorAll(
                            ".gHeader__dContent__nonspecialHeading"
                        )
                    ).forEach(item => {
                        item.classList.replace(
                            "gHeader__dContent__nonspecialHeading",
                            "gHeader__dContent__specialHeading"
                        );
                    });
                    node.classList.replace(
                        "gHeader__dContent__ul--nonspecial",
                        "gHeader__dContent__ul--special"
                    );
                }
            });
        });
    });
};

const specialBackLinksLogic = () => {
    specialBackLinks.forEach(item => {
        item.addEventListener("click", e => {
            e.preventDefault();

            const parent =
                e.currentTarget.parentElement.parentElement.parentElement;

            const oldUl = parent.querySelector(
                ".gHeader__dContent__ul--special"
            );

            oldUl.classList.replace(
                "gHeader__dContent__ul--special",
                "gHeader__dContent__ul--nonspecial"
            );
            Nodes(
                parent.querySelectorAll(".gHeader__dContent__specialHeading")
            ).forEach(item => {
                item.classList.replace(
                    "gHeader__dContent__specialHeading",
                    "gHeader__dContent__nonspecialHeading"
                );
            });
            parent
                .querySelector(".gHeader__dContent__ul--nonspecial")
                .classList.replace(
                    "gHeader__dContent__ul--nonspecial",
                    "gHeader__dContent__ul--special"
                );
            parent
                .querySelector(".gHeader__dContent__nonspecialHeading")
                .classList.replace(
                    "gHeader__dContent__nonspecialHeading",
                    "gHeader__dContent__specialHeading"
                );
        });
    });
};

const handleParentLinkClick = e => {
    e.preventDefault();
    e.currentTarget.parentElement.classList.toggle("gHeader__li--active");
};

const handleBackToParentClick = e => {
    e.preventDefault();
    e.currentTarget.parentElement.parentElement.parentElement.classList.remove(
        "gHeader__li--active"
    );
};

const handleClearMenu = e => {
    e.preventDefault();
    e.currentTarget.parentElement
        .querySelectorAll(".gHeader__li")
        .forEach(i => i.classList.remove("gHeader__li--active"));
    e.currentTarget.classList.add("gHeader__li--active");
};

const handleResetMenu = e => {
    e.preventDefault();
    e.currentTarget.parentElement
        .querySelectorAll(".gHeader__li")
        .forEach(i =>
            i.classList.remove("gHeader__li--active", "gHeader__li--isActive")
        );
    if (
        e.currentTarget.classList.contains("gHeader__li--tierOne") ||
        e.currentTarget.classList.contains("gHeader__li--static")
    ) {
        e.currentTarget.parentElement
            .querySelectorAll(
                ".gHeader__li--tierTwo:first-of-type, .gHeader__li--tierThree:first-of-type"
            )
            .forEach(i => i.classList.add("gHeader__li--isActive"));
    }
};

const hamburgerLogic = () => {
    hamburger.addEventListener("click", e => {
        e.preventDefault();
        hamburger.querySelector(".hamburger").classList.toggle("is-active");
        mainMenu.classList.toggle("gHeader__ul--active");
    });
};

const makeDetails = () => {
    const allDetailTags = Nodes(Elements(".gHeader__dContent__details"));

    const allSummaryTags = Nodes(Elements(".gHeader__dContent__summary"));

    allSummaryTags.forEach(item => {
        if (item.tagName === "SUMMARY") return;
        if (item.tagName === "DIV") {
            parseTagMethod(item, "summary", ["gHeader__dContent__summary"]);
        }
    });
    allDetailTags.forEach(item => {
        if (item.tagName === "DETAILS") return;
        if (item.tagName === "DIV") {
            parseTagMethod(item, "details", [
                "gHeader__dContent__heading",
                "gHeader__dContent__heading--subheading",
                "gHeader__dContent__details"
            ]);
        }
    });
    allSpecialULs.forEach(item => {
        item.classList.replace(
            "gHeader__dContent__ul--special",
            "gHeader__dContent__ul--nonspecial"
        );
    });
    allSpecialHeadings.forEach(item => {
        item.classList.replace(
            "gHeader__dContent__specialHeading",
            "gHeader__dContent__nonspecialHeading"
        );
    });
};

const makeDiv = () => {
    const allDetailTags = Nodes(Elements(".gHeader__dContent__details"));

    const allSummaryTags = Nodes(Elements(".gHeader__dContent__summary"));

    allSummaryTags.forEach(item => {
        if (item.tagName === "DIV") return;
        parseTagMethod(item, "div", ["gHeader__dContent__summary"]);
    });
    allDetailTags.forEach(item => {
        if (item.tagName === "DIV") return;
        parseTagMethod(item, "div", [
            "gHeader__dContent__heading",
            "gHeader__dContent__heading--subheading",
            "gHeader__dContent__details"
        ]);
    });

    contentBodies.forEach(itemBody => {
        Nodes(
            itemBody.querySelectorAll(".gHeader__dContent__specialHeading")
        ).forEach(item => {
            item.classList.replace(
                "gHeader__dContent__specialHeading",
                "gHeader__dContent__nonspecialHeading"
            );
        });
        Nodes(
            itemBody.querySelectorAll(".gHeader__dContent__ul--special")
        ).forEach(item => {
            item.classList.replace(
                "gHeader__dContent__ul--special",
                "gHeader__dContent__ul--nonspecial"
            );
        });

        const firstSpecialHeading = itemBody.firstChild;
        const firstSpecialList =
            firstSpecialHeading === null
                ? false
                : firstSpecialHeading.nextSibling;

        firstSpecialHeading &&
            firstSpecialHeading.classList.replace(
                "gHeader__dContent__nonspecialHeading",
                "gHeader__dContent__specialHeading"
            );
        if (
            firstSpecialList &&
            firstSpecialList.classList.contains("gHeader__dContent__ul--l4")
        ) {
            firstSpecialList.classList.replace(
                "gHeader__dContent__ul--nonspecial",
                "gHeader__dContent__ul--special"
            );
        }
    });
};

const changeMarkup = () => {
    if (window.innerWidth > 768) {
        makeDiv();
    } else {
        makeDetails();
    }
};

const tierTwoMouseEnter = () => {
    tierTwoFirstLink.classList.remove(
        "gHeader__li--active",
        "gHeader__li--isActive"
    );
    tierTwoFirstLink
        .querySelector(".gHeader__li--tierThree:first-child")
        .classList.remove(
            "gHeader__li--active",
            "gHeader__li--isActive"
        );
};

const tierTwoMouseLeave = () => {
    tierTwoFirstLink.classList.add(
        "gHeader__li--active",
        "gHeader__li--isActive"
    );
    tierTwoFirstLink
        .querySelector(".gHeader__li--tierThree:first-child")
        .classList.add(
            "gHeader__li--active",
            "gHeader__li--isActive"
        );
};

const tierTwoFirstItemMouseLeave = () => {
    tierTwoFirstLink.classList.add(
        "gHeader__li--active",
        "gHeader__li--isActive"
    );
    tierTwoFirstLink
        .querySelector(".gHeader__li--tierThree:first-child")
        .classList.add(
            "gHeader__li--active",
            "gHeader__li--isActive"
        );
    tierTwoLastLink
        .querySelector(".gHeader__li--isFirstItem")
        .classList.add(
            "gHeader__li--active",
            "gHeader__li--isActive"
        );
};

const tierThreeFirstItemMouseLeave = () => {
    tierThreeFirstLink.classList.add(
        "gHeader__li--active",
        "gHeader__li--isActive"
    );
    shopAppFirstLink.classList.add(
        "gHeader__li--active",
        "gHeader__li--isActive"
    );
};

const tierThreeMouseEnter = () => {
    tierThreeFirstLink.classList.remove(
        "gHeader__li--active",
        "gHeader__li--isActive"
    );
    shopAppFirstLink.classList.remove(
        "gHeader__li--active",
        "gHeader__li--isActive"
    );
};

const tierThreeMouseLeave = () => {
    tierThreeFirstLink.classList.add(
        "gHeader__li--active",
        "gHeader__li--isActive"
    );
};

const tierThree12And13 = () => {
    shopAppFirstLink.classList.add(
        "gHeader__li--active",
        "gHeader__li--isActive"
    );
};

const tierFourMouseOver = e => {
    e.stopPropagation();
    thirdLevelCategoryList.forEach(i => {
        i.classList.add("gHeader__ul--in");
    });
};

const tierFourMouseOut = () => {
    thirdLevelCategoryList.forEach(i => {
        i.classList.remove("gHeader__ul--in");
    });
};

const declareMethods = () => {
    // https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
    let vh = window.innerHeight * 0.01;

    document.documentElement.style.setProperty("--vh", `${vh}px`);
    window.addEventListener("resize", () => {
        let vh = window.innerHeight * 0.01;

        document.documentElement.style.setProperty("--vh", `${vh}px`);
    });
    if (window.innerWidth > 768) {
        mainMenu.classList.remove("gHeader__ul--active");
        hamburger.querySelector(".hamburger").classList.remove("is-active");
        allParentLinks.forEach(link => {
            if (!link.classList.contains("gHeader__li__a--tierTwo") && !link.classList.contains("gHeader__li__a--tierThree")) {
                link.addEventListener("click", e => e.preventDefault());
            }
            // link.removeEventListener("click", handleParentLinkClick);
        });
        allBackToParentLinks.forEach(link => {
            link.addEventListener("click", e => e.preventDefault());
            // link.removeEventListener("click", handleBackToParentClick);
        });
        allParentItemLinks.forEach(link => {
            link.classList.remove("gHeader__li--active");
            link.addEventListener("mouseenter", handleClearMenu);
            link.addEventListener("mouseleave", handleResetMenu);
        });
        tierTwoLinks.forEach((item, index) => {
            if (index > 0) {
                item.addEventListener("mouseenter", tierTwoMouseEnter);
                item.addEventListener("mouseleave", tierTwoMouseLeave);
            }
            item.addEventListener("mouseleave", tierTwoFirstItemMouseLeave);
        });
        tierThreeLinks.forEach((item, index) => {
            item.addEventListener("mouseleave", tierThreeFirstItemMouseLeave);
            if (index > 0) {
                item.addEventListener("mouseenter", tierThreeMouseEnter);
                item.addEventListener("mouseleave", tierThreeMouseLeave);
            }
            // FT. Link || Antibodies and Reagents
            if (index === 12 || index === 13) {
                item.addEventListener("mouseenter", tierThree12And13);
                item.addEventListener("mouseleave", tierThree12And13);
            }
        });
        thirdLevelApplicationList.forEach(item => {
            item.classList.add("gHeader__ul--on");
        });
        fourthLevelList.forEach(item => {
            item.addEventListener("mouseover", tierFourMouseOver);
            item.addEventListener("mouseout", tierFourMouseOut);
        });
    } else {
        allParentLinks.forEach(link => {
            link.addEventListener("click", handleParentLinkClick);
        });
        allBackToParentLinks.forEach(link => {
            link.addEventListener("click", handleBackToParentClick);
        });
        // REMOVE EVENTS THAT ARE MEANT FOR DESKTOP SITE
        allParentItemLinks.forEach(link => {
            link.removeEventListener("mouseenter", handleClearMenu);
            link.removeEventListener("mouseleave", handleResetMenu);
        });
        tierTwoLinks.forEach((item, index) => {
            if (index > 0) {
                item.removeEventListener("mouseenter", tierTwoMouseEnter);
                item.removeEventListener("mouseleave", tierTwoMouseLeave);
            }
            item.removeEventListener("mouseleave", tierTwoFirstItemMouseLeave);
        });
        tierThreeLinks.forEach((item, index) => {
            item.removeEventListener("mouseleave", tierThreeFirstItemMouseLeave);
            if (index > 0) {
                item.removeEventListener("mouseenter", tierThreeMouseEnter);
                item.removeEventListener("mouseleave", tierThreeMouseLeave);
            }
            if (index === 12 || index === 13) {
                item.removeEventListener("mouseenter", tierThree12And13);
                item.removeEventListener("mouseleave", tierThree12And13);
            }
        });
        fourthLevelList.forEach(item => {
            item.removeEventListener("mouseover", tierFourMouseOver);
            item.removeEventListener("mouseout", tierFourMouseOut);
        });
    }
    changeMarkup();
};

const init = () => {
    window.addEventListener("resize", declareMethods);
    hamburgerLogic();
    declareMethods();
    paginationInit();
    specialLinksLogic();
    specialBackLinksLogic();
};

window.addEventListener("load", init);
